/**
 * Used by angular to serve variables based on the the environment
 */
export const environment = {
  /**
   * This is a production environment
   */
  production: true,
  API_URL: 'http://localhost:3000',
  //API_URL: 'https://api.convoerter.elearn.rwth-aachen.de',
};
